export default __webpack_public_path__ + "static/media/Immagine_11.6c1c5afb.jpg";